import React, { Component } from "react";
import { Button, Input, Tooltip } from "../../../../GeneralComponents/ui";
import i18n from "../../../../../Utils/i18next";
import { showNotificationWithIcon } from "../../../../../Utils/Notification";
import uuid from "react-uuid";
import { SaveOutlined, CloseOutlined } from "@ant-design/icons";

// What if scenario add operations
export default class WhatIfScenarios extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      visibleSaveOperation: false,
    };
  }

  /** To open scenario save area. */
  openSaveScenarioButton = (
    <Tooltip title={i18n.t("Dashboard.Data.WhatIf.SaveCurrentScenario")}>
      <Button
        icon={<SaveOutlined />}
        onClick={() => this.visibleSaveOperation(true)}
        style={{ marginLeft: 8 }}
      />
    </Tooltip>
  );

  //Save button for current scenario
  saveCurrentScenarioButton = (
    <SaveOutlined
      name={"scenarioSaveButton"}
      onClick={() => this.saveCurrentScenario(this.props.parameters)}
      className={"circle-icon"}
      style={{
        cursor: "pointer",
        top: "-3px",
        position: "relative",
        marginLeft: "5px",
        color: "#71ab8a",
        borderColor: "#71ab8a",
      }}
    ></SaveOutlined>
  );

  //To cancel scenario save area.
  cancelCurrentScenarioButton = (
    <CloseOutlined
      name={"scenarioCancelButton"}
      onClick={() => this.visibleSaveOperation(false)}
      className={"circle-icon"}
      style={{
        cursor: "pointer",
        top: "-3px",
        position: "relative",
        marginLeft: "5px",
        color: "#e87d7d",
        borderColor: "#e87d7d",
      }}
    ></CloseOutlined>
  );

  /** Visibility handler for save operations */
  visibleSaveOperation = (status) => {
    let newState = { ...this.state };
    newState.visibleSaveOperation = status;

    if (status === false) {
      newState.name = "";
    }
    this.setState(newState);
  };

  /** Validate and save current scenario with unique id. */
  saveCurrentScenario = (parameters) => {
    let scenario = {};

    scenario.id = uuid();
    scenario.name = this.state.name;

    if (scenario.name === "" || scenario.name === undefined) {
      showNotificationWithIcon(
        i18n.t("Error"),
        i18n.t("Dashboard.Data.WhatIf.ScenarioNameError"),
        "error",
      );
      return;
    }

    scenario.scenarioParametersList = [];

    parameters.map((param) => {
      scenario.scenarioParametersList.push({
        id: param.id,
        currentValue: param.currentValue,
      });
    });

    showNotificationWithIcon(
      i18n.t("Success"),
      i18n.t("Dashboard.Data.WhatIf.ScenarioSuccessfullyAdded"),
      "success",
    );

    this.setState(
      {
        ...this.state,
        visibleSaveOperation: false,
        name: "",
      },
      () => this.props.addScenario(scenario),
    );
  };

  /** Set scenario name */
  setName = (name) => {
    this.setState({
      ...this.state,
      name: name,
    });
  };

  render() {
    let saveVisibleClass = "save-scenario-area";

    if (this.state.visibleSaveOperation === true) {
      saveVisibleClass = "save-scenario-area show-scenario";
    }

    // If save operation is visible, show the input form overlaid or inline
    // If not, show the trigger button
    if (this.state.visibleSaveOperation) {
        return (
            <div className={saveVisibleClass} style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                <Input
                    id={"scenarioName"}
                    placeholder={i18n.t("Dashboard.Data.WhatIf.ScenarioName")}
                    onChange={(e) => {
                        this.setName(e.target.value);
                    }}
                    value={this.state.name}
                    style={{ flex: 1 }}
                    size="small"
                />
                {this.saveCurrentScenarioButton}
                {this.cancelCurrentScenarioButton}
            </div>
        );
    }

    return this.openSaveScenarioButton;
  }
}
